// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__mH_gu","desc":"styles_desc__2P0DQ"};